import React from 'react'
import TerritorySkinFormPage from './TerritorySkinFormPage'

export default function AppTerritorySkin(props) {
    const { type, territorySkinId } = props.match.params

    return (
        <TerritorySkinFormPage
            mode="edit"
            routeType={type}
            territorySkinId={territorySkinId}
        />
    )
}
